import React from "react";
import {
	CashbackItemAmountBlockStyled,
	CashbackItemAmountLabelStyled,
	CashbackItemAmountValueStyled,
	CashbackItemBodyStyled,
	CashbackItemClaimButtonStyled,
	CashbackItemHeaderStyled,
	CashbackItemStatusMessageStyled,
	CashbackItemTitleStyled,
	CashbackItemWrapperStyled,
} from "./elements";

const formatAmount = (amount, locale) => {
	if (typeof amount !== "number") return amount;
	try {
		return new Intl.NumberFormat(locale || undefined, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		}).format(amount);
	} catch (error) {
		return amount.toFixed(2);
	}
};

const CashbackItem = ({ cashback, isClaiming, isAnyClaiming, onClaim, translate, locale }) => {
	const {
		cashbackId,
		name,
		currency,
		claimableAmount,
		isDeserved,
		statusMessage,
	} = cashback || {};

	const canClaim = !!isDeserved && typeof claimableAmount === "number" && claimableAmount > 0;

	const handleClaim = () => {
		if (!canClaim || isAnyClaiming) return;
		onClaim(cashbackId);
	};

	return (
		<CashbackItemWrapperStyled>
			<CashbackItemHeaderStyled>
				<CashbackItemTitleStyled>{name}</CashbackItemTitleStyled>
			</CashbackItemHeaderStyled>
			<CashbackItemBodyStyled>
				<CashbackItemAmountBlockStyled>
					<CashbackItemAmountLabelStyled>
						{translate("cashback.adhoc.amount")}
					</CashbackItemAmountLabelStyled>
					<CashbackItemAmountValueStyled muted={!canClaim}>
						{canClaim
							? `${formatAmount(claimableAmount, locale)} ${currency || ""}`.trim()
							: translate("cashback.adhoc.notDeserved")}
					</CashbackItemAmountValueStyled>
				</CashbackItemAmountBlockStyled>
				{!canClaim && statusMessage ? (
					<CashbackItemStatusMessageStyled>
						{statusMessage}
					</CashbackItemStatusMessageStyled>
				) : null}
				<CashbackItemClaimButtonStyled
					type="button"
					disabled={!canClaim || isAnyClaiming}
					onClick={handleClaim}>
					{isClaiming
						? translate("cashback.adhoc.claiming")
						: translate("cashback.adhoc.claim")}
				</CashbackItemClaimButtonStyled>
			</CashbackItemBodyStyled>
		</CashbackItemWrapperStyled>
	);
};

export default CashbackItem;
